import Vue from 'vue'
import App from './App.vue'


/* Inizio ElementUI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/it'
Vue.use(ElementUI, { locale })
/* Fine ElementUI */
        

/* Inizio TerAs */
var vueData = {}
import VueMoment from './teras/vue-moment'
Vue.use(VueMoment,'it')
import teras from './teras'
Vue.prototype.$teras = teras
vueData.teras = teras
import axios from './teras/tAxios'
Vue.prototype.$axios = axios
vueData.axios = axios

import './css/big.css'
/* Fine TerAs */
        

/* Inizio Router */
import router from'./router'
/* Fine Router */
        

/* Inizio Storage */
import storage from './teras/tStorage' 
Vue.prototype.$storage = storage
vueData.storage = storage
/* Fine Storage */
        
Vue.config.productionTip = false

/* Inizio TerAs-event */
teras.event.on('routerFirst', function(to) {
  teras.app.step++
  teras.app.routeInitial = to.path
})
teras.event.on('appReady', function() {
console.log("appReady appReady appReady appReady appReady appReady appReady")
router.push(teras.app.routeInitial)
})
teras.event.on('appExit', function() {
})
/* Fine TerAs-event */
        

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
